import { useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { selectIsLoyaltyFilterChecked, setIsLoyaltyFilterChecked } from '../../../core/reducers/specialOffers';
import { useAppDispatch, useAppSelector } from '../../../core/utils';
import { LOYALTY_URL_PARAM } from '../../../utils/constants';
const useLoyaltyOfferFilter = () => {
    const { search } = useLocation();
    const dispatch = useAppDispatch();
    const isFilterChecked = useAppSelector(selectIsLoyaltyFilterChecked);
    const decodedQueryString = decodeURIComponent(search);
    const searchParams = useMemo(() => new URLSearchParams(decodedQueryString), [decodedQueryString]);
    const canShowLoyaltyFilter = searchParams.get(LOYALTY_URL_PARAM) === 'true';
    const toggleLoyaltyFilter = useCallback(() => dispatch(setIsLoyaltyFilterChecked(!isFilterChecked)), [dispatch, isFilterChecked]);
    return { isFilterChecked, toggleLoyaltyFilter, canShowLoyaltyFilter };
};
export default useLoyaltyOfferFilter;
